module.exports = __webpack_public_path__ + "media/images/openrounds_logo_white-1baddbbddfbee877d167b0e38f88e078.png";